<template>
  <div class="setting_modal">
    <div class="setting_customize">
      <div class="setting_customize_header">
        <p class="setting_customize_header_title">
          {{ labelProperties.PREVIEW_TITLE }}
        </p>
        <div class="setting_customize_header_close" @click="closeModal">
          <svg width="12" height="12" xmlns="http://www.w3.org/2000/svg">
            <g fill="#AAA" fill-rule="evenodd">
              <path d="M.255 1.545l.99-.99 9.9 9.9-.99.99z"/>
              <path d="M10.155.555l.99.99-9.9 9.9-.99-.99z"/>
            </g>
          </svg>
        </div>
      </div>
      <div class="setting_customize_body">
        <div class="setting_customize_preview" v-bind:style="{ backgroundColor: colors.pageBackground }">
          <div class="jobs_wrapper">
            <h1 class="jobs_page_title_preview setting_word_break" v-bind:style="{ color: colors.pageText }" v-if="entryPageName">
              {{ entryPageName }}
            </h1>
            <h1 class="jobs_page_title" v-bind:style="{ color: colors.pageText }" v-else>
              {{ labelProperties.ENTRY_PAGE_TITLE }}
            </h1>
            <p class="jobs_table_annotation_preview setting_word_break" v-if="entryOverview">{{ entryOverview }}</p>
            <div class="entry_stepbar">
              <ul class="entry_stepbar_list" v-bind:style="{ border: '1px solid' + colors.borderColor }">
                <li class="entry_stepbar_item"
                    v-bind:style="[step >= 1 ? {backgroundColor: colors.keyColor, '--keyColor': colors.keyColor} : {}]">
                  <span class="entry_stepbar_label"
                        v-if="message && message.titleEntry && message.titleEntry.length <= messageSettingsProperties.TITLE.ENTRY_TITLE_MAX_LENGTH"
                        v-bind:style="[step >= 1 ? {color: colors.highlightText} : {}]">
                    {{ message.titleEntry }}
                  </span>
                  <span class="entry_stepbar_label" v-else
                        v-bind:style="[step >= 1 ? { color: colors.highlightText } : {}]">
                    {{ labelProperties.ENTRY_STEP_TITLE }}
                  </span>
                </li>
                <li class="entry_stepbar_item"
                    v-bind:style="[step >= 2 ? {backgroundColor: colors.keyColor, '--keyColor': colors.keyColor} : {backgroundColor: colors.subColor, '--keyColor': colors.subColor}]">
                  <span class="entry_stepbar_label"
                        v-if="message && message.titleConfirm && message.titleConfirm.length <= messageSettingsProperties.TITLE.CONFIRM_TITLE_MAX_LENGTH"
                        v-bind:style="[step >= 2 ? { color: colors.highlightText } : { color: colors.pageText }]">
                    {{ message.titleConfirm }}
                  </span>
                  <span class="entry_stepbar_label" v-else
                        v-bind:style="[step >= 2 ? { color: colors.highlightText } : { color: colors.pageText }]">
                    {{ labelProperties.CONFIRM_STEP_TITLE }}
                  </span>
                </li>
                <li class="entry_stepbar_item"
                    v-bind:style="[step >= 3 ? {backgroundColor: colors.keyColor, '--keyColor': colors.keyColor} : { backgroundColor: colors.subColor }]">
                  <span class="entry_stepbar_label"
                        v-if="message && message.titleCompletion && message.titleCompletion.length <= messageSettingsProperties.TITLE.COMPLETE_TITLE_MAX_LENGTH"
                        v-bind:style="[step >= 3 ? { color: colors.highlightText } : { color: colors.pageText }]">
                    {{ message.titleCompletion }}
                  </span>
                  <span class="entry_stepbar_label" v-else
                        v-bind:style="[step >= 3 ? { color: colors.highlightText } : { color: colors.pageText }]">
                    {{ labelProperties.COMPLETE_STEP_TITLE }}
                  </span>
                </li>
              </ul>
            </div>
            <div v-show="step === 1" v-bind:style="{ backgroundColor: colors.pageBackground }">
              <div v-if="draftCategories.length > 0">
                <div v-for="(category, index) in draftCategories" :key="index">
                  <div v-if="category && !category.categoryDeleted && !isEmptyCategory(index)" class="mt-2">
                    <h2 class="jobs_category_title"
                        v-bind:style="{color: colors.pageText, borderLeftColor: colors.keyColor}">
                      {{ category.categoryName }}
                      <span v-if="category.countCate">
                        {{ category.countCate }}
                      </span>
                    </h2>
                    <div class="jobs_table_wrapper">
                      <table class="jobs_table" v-for="(item, indexItem) in category.item" :key="indexItem">
                        <template v-if="!isEmptyItem(item)">
                          <tbody class="jobs_table_body">
                          <tr class="jobs_table_rows">
                            <th class="jobs_table_head"
                                v-bind:style="[{ backgroundColor: colors.subColor }, indexItem === 0 ? { border: '1px solid' + colors.borderColor } : {borderLeft: '1px solid' + colors.borderColor, borderRight: '1px solid' + colors.borderColor, borderBottom: '1px solid' + colors.borderColor}]">
                              <div class="jobs_table_head_holder">
                                <span class="jobs_table_label" v-bind:style="{ color: colors.pageText }">
                                  {{ item.itemName }}
                                </span>
                                <span class="entry_required_label" v-if="item.itemRequired"
                                      v-bind:style="{backgroundColor: colors.requiredLabel, color: colors.requiredLabelText}">
                                  {{ labelProperties.LABEL_REQUIRE }}
                                </span>
                              </div>
                              <div v-if="item.resourceField.length === 1 && (item.resourceField[0].min_length || item.resourceField[0].max_length)" class="setting_range_allow_input">
                                <span v-if="item.resourceField[0].type === 'textarea' || item.resourceField[0].type === 'text' || item.resourceField[0].type.includes('email') || item.resourceField[0].type === 'tel' || item.resourceField[0].type === 'url'">{{labelProperties.WORD_COUNT}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                                <span v-if="item.resourceField[0].type === 'integer' || item.resourceField[0].type === 'calc' || item.resourceField[0].type === 'number'">{{labelProperties.RANGE}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                              </div>
                            </th>
                            <td class="jobs_table_cell"
                                v-bind:style="[indexItem === 0 ? { border: '1px solid' + colors.borderColor } : {borderLeft: '1px solid' + colors.borderColor, borderRight: '1px solid' + colors.borderColor, borderBottom: '1px solid' + colors.borderColor}]">
                              <div class="jobs_table_form_rows">
                                <div class="jobs_table_form_item">
                                  <div v-for="(resourceField, indexResourceField) in buildListItem(item.resourceField)"
                                       :key="indexResourceField" class="row">
                                    <div class="col" v-for="(resource, indexResource) in resourceField.filter(resourceSetting => resourceSetting && !resourceSetting.isDeletedByMainSystem)"
                                         :key="indexResource">
                                      <div v-if="resource.type !== 'blank'">
                                        <InputComponent
                                            class="mt-2"
                                            :resource="resource"
                                            :indexResource="indexResourceField"
                                            :master="getMasterData(resource.master_name)"
                                            :year="year"
                                            :month="month"
                                            :day="day"
                                            :draftColors="colors"
                                            :isDisableEditing="isDisableEditing"
                                            :numberOfItem="item.resourceField.length"
                                            :itemName="item.itemName"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <span class="jobs_table_annotation setting_word_break" v-if="item.viewAnnotation"
                                        v-bind:style="{ color: colors.pageText }">
                                    ※{{ item.annotationText }}
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </table>
                    </div>
                    <div class="setting_unit_add" v-if="index === findLastCategoryIndex('careers')">
                      <a class="setting_unit_add_btn" @click.prevent="duplicateCategory(index)">
                        {{ labelProperties.DUPLICATE_CARRIER }}
                      </a>
                    </div>
                    <div class="setting_unit_add" v-if="index === findLastCategoryIndex('educations')">
                      <a class="setting_unit_add_btn" @click.prevent="duplicateCategory(index)">
                        {{ labelProperties.DUPLICATE_EDUCATION }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="privacy.isEnabledPolicy && privacy.content !== ''" class="mt-2">
                <h2 class="jobs_category_title"
                    v-bind:style="{color: colors.pageText, borderLeftColor: colors.keyColor}">
                  {{ labelProperties.PRIVACY_POLICY_CATEGORY }}
                </h2>
                <textarea class="jobs_form_textarea" readonly v-model="privacy.content"/>
                <div class="entry_policy_checkbox">
                  <label class="jobs_form_label">
                    <input type="checkbox" v-model="agreePrivacyPolicy"/>
                    <span class="entry_policy_checkbox_text" v-bind:style="{ color: colors.pageText }">
                      {{ labelProperties.PRIVACY_POLICY_DEFAULT }}
                    </span>
                  </label>
                </div>
              </div>
              <div class="entry_policy_checkbox" v-if="privacy.isEnabledUrl && privacy.textLink !== ''">
                <label class="jobs_form_label">
                  <input v-model="agreePrivacyPolicyLink" type="checkbox"/>
                  <a :href="privacy.url" class="ml-1 mr-3" target="_blank"
                     v-bind:style="{ color: colors.linkText }">
                    {{ privacy.textLink }}
                  </a>
                </label>
              </div>
              <div class="jobs_btn_box">
                <button class="jobs_btn_primary" @click="nextStep(2)"
                        v-bind:style="{color: colors.mainButtonText, backgroundColor: colors.mainButton, border: '1px solid' + colors.borderColor}">
                  <span
                      v-if="!button.confirmButton || button.confirmButton.length > buttonSettingsProperties.CONFIRM_BUTTON_MAX_LENGTH">
                    {{ labelProperties.CONFIRM_BUTTON }}
                  </span>
                  <span v-else>
                    {{ button.confirmButton }}
                  </span>
                </button>
              </div>
            </div>

            <div v-show="step === 2" v-bind:style="{ backgroundColor: colors.pageBackground }">
              <div class="entry_confirm">
                <pre class="entry_confirm_text customize_setting_entry_confirm" v-if="message && message.messageConfirm && message.messageConfirm.length <= messageSettingsProperties.MESSAGE.CONFIRM_BODY_MAX_LENGTH">{{message.messageConfirm}}</pre>
              </div>
              <div v-if="draftCategories.length > 0">
                <div v-for="(category, index) in draftCategories" :key="index">
                  <div v-if="category && !category.categoryDeleted && !isEmptyCategory(index)" class="mt-2">
                    <h2 class="jobs_category_title"
                        v-bind:style="{color: colors.pageText, borderLeftColor: colors.keyColor}">
                      {{ category.categoryName }}
                      <span v-if="category.countCate">
                        {{ category.countCate }}
                      </span>
                    </h2>
                    <div class="jobs_table_wrapper">
                      <table class="jobs_table" v-for="(item, indexItem) in category.item" :key="indexItem">
                        <template v-if="!isEmptyItem(item)">
                          <tbody class="jobs_table_body">
                          <tr class="jobs_table_rows">
                            <th class="jobs_table_head"
                                v-bind:style="[{ backgroundColor: colors.subColor }, indexItem === 0 ? { border: '1px solid' + colors.borderColor } : {borderLeft: '1px solid' + colors.borderColor, borderRight: '1px solid' + colors.borderColor, borderBottom: '1px solid' + colors.borderColor}]">
                              <div class="jobs_table_head_holder">
                                <span class="jobs_table_label" v-bind:style="{ color: colors.pageText }">
                                  {{ item.itemName }}
                                </span>
                                <span class="entry_required_label" v-if="item.itemRequired"
                                      v-bind:style="{backgroundColor: colors.requiredLabel, color: colors.requiredLabelText}">
                                  {{ labelProperties.LABEL_REQUIRE }}
                                </span>
                              </div>
                              <div v-if="item.resourceField.length === 1 && (item.resourceField[0].min_length || item.resourceField[0].max_length)" class="setting_range_allow_input">
                                <span v-if="item.resourceField[0].type === 'textarea' || item.resourceField[0].type === 'text' || item.resourceField[0].type.includes('email') || item.resourceField[0].type === 'tel' || item.resourceField[0].type === 'url'">{{labelProperties.WORD_COUNT}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                                <span v-if="item.resourceField[0].type === 'integer' || item.resourceField[0].type === 'calc' || item.resourceField[0].type === 'number'">{{labelProperties.RANGE}} {{item.resourceField[0].min_length}} ~ {{item.resourceField[0].max_length}}</span>
                              </div>
                            </th>
                            <td class="jobs_table_cell"
                                v-bind:style="[indexItem === 0 ? { border: '1px solid' + colors.borderColor } : {borderLeft: '1px solid' + colors.borderColor, borderRight: '1px solid' + colors.borderColor, borderBottom: '1px solid' + colors.borderColor}]">
                              <div class="jobs_table_form_rows">
                                <div class="jobs_table_form_item">
                                  <div v-for="(resourceField, indexResourceField) in buildListItem(item.resourceField)"
                                       :key="indexResourceField" class="row">
                                    <div class="col" v-for="(resource, indexResource) in resourceField.filter(resourceSetting => resourceSetting && !resourceSetting.isDeletedByMainSystem)"
                                         :key="indexResource">
                                      <div v-if="resource.type !== 'blank'">
                                        <InputComponent
                                            class="mt-2"
                                            :resource="resource"
                                            :indexResource="indexResourceField"
                                            :master="getMasterData(resource.master_name)"
                                            :year="year"
                                            :month="month"
                                            :day="day"
                                            :draftColors="colors"
                                            :isDisableEditing="isDisableEditing"
                                            :numberOfItem="item.resourceField.length"
                                            :itemName="item.itemName"
                                        />
                                      </div>
                                    </div>
                                  </div>
                                  <span class="jobs_table_annotation setting_word_break" v-if="item.viewAnnotation"
                                        v-bind:style="{ color: colors.pageText }">
                                    ※{{ item.annotationText }}
                                  </span>
                                </div>
                              </div>
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </table>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="privacy.isEnabledPolicy && privacy.content !== ''" class="mt-2">
                <h2 class="jobs_category_title"
                    v-bind:style="{color: colors.pageText, borderLeftColor: colors.keyColor}">
                  {{ labelProperties.PRIVACY_POLICY_CATEGORY }}
                </h2>
                <textarea class="jobs_form_textarea" readonly v-model="privacy.content"/>
                <div class="entry_policy_checkbox">
                  <label class="jobs_form_label">
                    <input type="checkbox" v-model="agreePrivacyPolicy" disabled />
                    <span class="entry_policy_checkbox_text" v-bind:style="{ color: colors.pageText }">
                      {{ labelProperties.PRIVACY_POLICY_DEFAULT }}
                    </span>
                  </label>
                </div>
              </div>
              <div class="entry_policy_checkbox" v-if="privacy.isEnabledUrl && privacy.textLink !== ''">
                <label class="jobs_form_label">
                  <input v-model="agreePrivacyPolicyLink" type="checkbox" disabled />
                  <a :href="privacy.url" target="_blank" class="ml-1 mr-3" v-bind:style="{ color: colors.linkText }">
                    {{ privacy.textLink }}
                  </a>
                </label>
              </div>
              <div class="jobs_btn_box">
                <button
                    class="jobs_btn_secondary"
                    @click="backStep(1)"
                    v-bind:style="{color: colors.subButtonText, backgroundColor: colors.subButton, border: '1px solid' + colors.borderColor}">
                  <span
                      v-if="!button.returnButton || button.returnButton.length > buttonSettingsProperties.RETURN_BUTTON_MAX_LENGTH">
                    {{ labelProperties.BACK_BUTTON }}
                  </span>
                  <span v-else>
                    {{ button.returnButton }}
                  </span>
                </button>
                <button class="jobs_btn_primary" @click="step = 3"
                        v-bind:style="{color: colors.mainButtonText, backgroundColor: colors.mainButton, border: '1px solid' + colors.borderColor}">
                  <span
                      v-if="!button.entryButton || button.entryButton.length > buttonSettingsProperties.ENTRY_BUTTON_MAX_LENGTH">
                    {{ labelProperties.ENTRY_BUTTON }}
                  </span>
                  <span v-else>
                    {{ button.entryButton }}
                  </span>
                </button>
              </div>
            </div>
            <div v-show="step === 3" v-bind:style="{ backgroundColor: colors.pageBackground }">
              <div class="entry_complete">
                <p class="entry_complete_title">
                  <span
                      v-if="message && message.messageTitleCompletion && message.messageTitleCompletion.length <= messageSettingsProperties.MESSAGE.COMPLETE_TITLE_MAX_LENGTH">
                    {{ message.messageTitleCompletion }}
                  </span>
                  <span v-else>
                    {{ labelProperties.MESSAGE_TITLE_COMPLETION_DEFAULT }}
                  </span>
                </p>
                <pre class="entry_complete_text customize_setting_entry_confirm mt-3" v-if="message && message.messageBodyCompletion && message.messageBodyCompletion.length <= messageSettingsProperties.MESSAGE.COMPLETE_BODY_MAX_LENGTH">{{message.messageBodyCompletion}}</pre>
                <p class="entry_complete_text mt-5" v-else>
                  {{ labelProperties.MESSAGE_CONTENT_1 }}
                  <br/>
                  {{ labelProperties.MESSAGE_CONTENT_2 }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="setting_customize_footer">
        <div class="setting_customize_footer_button">
          <button class="setting_btn_outline setting_btn_small" @click="closeModal">
            {{ labelProperties.BUTTON_CLOSE_MODAL }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import VueToast from "vue-toast-notification";
import InputComponent from "../GeneralComponents/InputComponent.vue";
import labelProperties
  from "../../../properties/entry_screen/customize_tab/popup-customize/popup-customize-labels.json";
import buttonSettingsProperties from "../../../properties/entry_screen/button_tab/button-maxlength-settings.json";
import messageSettingsProperties from "../../../properties/entry_screen/message_tab/message-maxlength-settings.json";

Vue.use(VueToast);

export default {
  name: "PreviewScreenSettings",
  components: {
    InputComponent,
  },
  props: [
    "categories",
    "colors",
    "message",
    "privacy",
    "masters",
    "button",
    "entryPageName",
    "entryOverview",
  ],
  data: function () {
    return {
      master: [],
      step: 1,
      applicationInformation: {},
      confirmInput: {},
      applicationCompleted: {},
      clientId: 1,
      value: {},
      agree: false,
      screen: {},
      color: "#714141",
      year: "",
      month: "",
      day: "",
      isDisableEditing: true,
      agreePrivacyPolicy: false,
      agreePrivacyPolicyLink: false,
      labelProperties: labelProperties,
      buttonSettingsProperties: buttonSettingsProperties,
      messageSettingsProperties: messageSettingsProperties,
      draftCategories: [],
    };
  },
  created() {
    this.handleBindDate();
  },
  updated() {
    this.handleBindDate();
  },
  watch: {
    categories(newVal) {
      this.draftCategories = JSON.parse(JSON.stringify(newVal));
    },
  },
  methods: {
    isEmptyCategory(index) {
      if (this.categories[index].item.length === 0) {
        return true;
      }

      return this.categories[index].item.filter(item => !this.isEmptyItem(item)).length === 0;
    },

    isEmptyItem(item) {
      if(item.itemDeleted) {
        return true;
      }

      if (item.resourceField.length === 1) {
        return item.resourceField[0].isDeletedByMainSystem;
      }

      if (item.resourceField.length > 1) {
        let numberItemDeleted = item.resourceField.filter(resourceSetting => resourceSetting && resourceSetting.isDeletedByMainSystem).length;
        return numberItemDeleted >= item.resourceField.length;
      }

      return true;
    },

    closeModal() {
      this.$emit("close");
      this.step = 1;
    },

    backStep(step) {
      this.handleBindDate();
      this.step = step;
    },

    nextStep(nextStep) {
      this.handleBindDate();
      this.step = nextStep;
    },

    handleBindDate() {
      if (!this.draftCategories) {
        return;
      }

      this.draftCategories.filter(category => category.item && category.item.length > 0).forEach(category => {
        category.item.filter(item => item.resourceField && item.resourceField.length > 0).forEach(item => {
          item.resourceField.filter(resource => resource.type === "date" && resource.name === "birth_date" && resource.default_value).forEach(resource => {
            const date = new Date(resource.default_value);
            this.year = date.getYear() + 1900;
            this.month = date.getMonth() + 1;
            this.day = date.getDate();
          });
        });
      });
    },

    buildListItem(resourceField) {
      let result = [];
      resourceField.forEach((field) => {
        if (!result || !result[field.itemDisplayOrder]) {
          result[field.itemDisplayOrder] = [field];
        } else if (result[field.itemDisplayOrder]) {
          result[field.itemDisplayOrder].push(field);
        }
      });

      return result;
    },

    getMasterData(master_name) {
      for (const master in this.masters) {
        if (master === master_name) {
          return [...this.masters[master].items];
        }
      }
    },

    checkCategoryItemsLength(index) {
      let length = 0;
      this.draftCategories[index].item.forEach((i) => {
        if (i.itemDeleted === undefined || i.itemDeleted === false) {
          length++;
        }
      });

      return length;
    },

    checkPropertyCategory(categoryIndex) {
      let propertyCategory = "";
      if (this.checkCategoryItemsLength(categoryIndex) !== 0) {
        for (let i = 0; i < this.draftCategories[categoryIndex].item.length; i++) {
          if (this.draftCategories[categoryIndex].item[i].itemDeleted) {
            continue;
          }

          let firstResourceName = this.draftCategories[categoryIndex].item[i].resourceField.find(resource => resource.itemDisplayOrder === 0 && resource.itemColumn === 0).name;
          if (firstResourceName.includes("educations.")) {
            propertyCategory = "educations";
            break;
          }

          if (firstResourceName.includes("careers.")) {
            propertyCategory = "careers";
            break;
          }
        }
      }

      return propertyCategory;
    },

    duplicateCategory(index) {
      if (!this.draftCategories[index].countCate) {
        this.draftCategories[index].countCate = 1;
      }

      let newCategory = JSON.parse(JSON.stringify(this.draftCategories[index]));
      newCategory.item.forEach(i => i.resourceField.forEach(resource => resource.default_value = ""));
      newCategory.countCate = this.draftCategories[index].countCate + 1;
      this.draftCategories.splice(index + 1, 0, newCategory);
    },

    findLastCategoryIndex(groupType) {
      let count = -1;
      this.draftCategories.forEach((_, i) => {
        if (this.checkPropertyCategory(i) === groupType) {
          count = i;
        }
      });

      return count;
    },
  },
};
</script>

<style scoped>
.setting_customize_preview {
  padding-left: unset !important;
}

.jobs_wrapper {
  padding: 10px !important;
  max-width: unset !important;
}

.entry_uploader_item_img {
  padding-top: 10px !important;
  display: flex;
  justify-content: space-between;
}

.entry_stepbar_item:not(:last-child)::after {
  border-left-color: var(--keyColor) !important;
}

.setting_customize_footer {
  display: unset !important;
}

p {
  margin-bottom: 0px !important;
}

.customize_setting_entry_confirm{
  word-break: break-all;
  white-space: pre-wrap;
}

.jobs_page_title_preview {
  font-size: 24px;
  font-weight: bold;
  margin-bottom: 15px !important;
}

.jobs_table_annotation_preview {
  margin-top: 8px;
  font-size: 14px;
  margin-bottom: 12px !important;
  white-space: break-spaces;
}
.jobs_page_title{
  margin-bottom: 12px !important;
}

.setting_word_break {
  word-break: break-all;
}
</style>
